<div class="selected-profile">
  @if (activeSession !== null) {
    <div class="active-session-info">
      <p-avatar
        shape="circle"
        size="normal"
        [label]="activeSession.claims[labelKey][0].toUpperCase()"
        [image]="activeSession.claims.imageUri"
      />
      <strong class="username">{{ activeSession.claims[labelKey] }}</strong>
    </div>
    <div class="active-session-actions">
      <p-menu #menu [model]="activeSessionActions" [popup]="true" [appendTo]="'body'" />
      <p-button (click)="menu.toggle($event)" link icon="pi pi-ellipsis-v" />
    </div>
  }
</div>
